import React, {Fragment} from 'react';

import { PostEditorFormFields } from "../formShapes";
import { Selector } from "../../../../../../components";
import {FORM_MODE, GOOGLE_CTA_OPTIONS} from "../../../../socialConstants";
import AddPhotoVideoAttachment from "../AddPhotoVideoAttachment";
import PostMediaAttachments from "../PostMediaAttachments";

const WhatsNewPost = (props) => {
  const { config, values, onChangeSetObject, mode } = props;
  const googlePost = values.googlePost ? values.googlePost : {};

  /** STYLES **/
  const containerStyle = "d-flex flex-column justify-content-between chatter-publish-textarea-container";
  const textContainerHeight = '100px';
  /** END STYLES **/

  /** HELPER FUNCTIONS **/
  const getSummary = () => googlePost.summary || "";

  const onTextChange = (e) => {
    onChangeSetObject({googlePost: {...googlePost, summary: e.target.value}});

    // Also copy the text into the text field so that it shows up in the Publishing Calendar when you click it.
    // This is a workaround since Google Local Posts may not be permanent and we don't have designs for the Post Details view.
    onChangeSetObject({text: e.target.value});
  };

  const ctaSupportsUrl = (callToActionType) => callToActionType && callToActionType !== "Call";

  const onCTAChange = (option) => {
    const callToActionType = option ? option.value : undefined;
    const callToActionURL = ctaSupportsUrl(callToActionType) ? googlePost.callToActionURL : undefined
    onChangeSetObject({ googlePost:  {...googlePost, callToActionType, callToActionURL } });
  }

  const getSelectedCTA = () => {
    if (!googlePost || !googlePost.callToActionType) return undefined;
    const { callToActionType } = googlePost;
    return GOOGLE_CTA_OPTIONS.find(opt => opt.value.toLowerCase() === callToActionType.toLowerCase());
  }

  const renderURLField = () => {
    if (!googlePost || !googlePost.callToActionType) return undefined;
    if (googlePost.callToActionType === "Call") {
      // Google will show the number from the Google My Business listing.
      return undefined;
    }

    return (
      <div className="d-flex mt-3">
        <div className="input-group block">
          <label>Link for your button</label>
          <input className="form-control" placeholder={"www.example.com"} type="text" value={getCTAUrl()} onChange={onCTAUrlChange} disabled={mode === FORM_MODE.VIEW} />
        </div>
      </div>
    );
  }

  const getCTAUrl = () => googlePost.callToActionURL ? googlePost.callToActionURL : undefined;

  const onCTAUrlChange = (e) => {
    if (!googlePost.callToActionType) return undefined;
    onChangeSetObject({ googlePost: { ...googlePost, callToActionURL: e.target.value } });
  }

  const renderCTASelector = () => {
    const selectedCTA = getSelectedCTA();
    if (!selectedCTA && mode === FORM_MODE.VIEW) return undefined;

    return (
      <Fragment>
        <div className="d-flex mt-3 h6">Add a button (optional)</div>
        <div className="d-flex w-20">
          <span className="w-100">
            <Selector
              options={GOOGLE_CTA_OPTIONS}
              onSelected={onCTAChange}
              selected={selectedCTA}
              renderOption={(option) => option.label}
              disabled={mode === FORM_MODE.VIEW}
            />
          </span>
        </div>
      </Fragment>
    );
  }
  /** END HELPER FUNCTIONS **/

  return (
    <div className={containerStyle} >
      <div className="d-flex" style={{minHeight: textContainerHeight}} >
        <textarea
          className="form-control content-spacer-top flex-grow-1"
          style={{ minHeight: textContainerHeight }}
          placeholder={config.textPlaceholder}
          value={getSummary()}
          onChange={onTextChange}
          disabled={mode === FORM_MODE.VIEW}
        />
      </div>
      { renderCTASelector() }
      { renderURLField() }
      <div className="d-flex flex-column justify-content-between mt-2">
        { mode === FORM_MODE.EDIT && (
          <div className="d-flex flex-row">
            <AddPhotoVideoAttachment {...props} />
          </div>
          )
        }
        <div className="d-flex flex-row">
          <PostMediaAttachments {...props}/>
        </div>
      </div>
    </div>
  );
}

WhatsNewPost.propTypes = PostEditorFormFields;

export default WhatsNewPost;
